"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DOMParser = void 0;
// Export classes
var DOMParserImpl_1 = require("./DOMParserImpl");
Object.defineProperty(exports, "DOMParser", { enumerable: true, get: function () { return DOMParserImpl_1.DOMParserImpl; } });
//# sourceMappingURL=index.js.map